const LISTE_PRODUITS_NON_COMMERCIALISABLE = {
  actions: {
    search: 'Rechercher',
    filtre: 'Filtre',
    edit: 'Modifier',
    archiver: 'Archiver',
    desarchiver: 'Désarchiver',
    delete: 'Supprimer',
    yes: 'Oui',
    no: 'Non',
  },
  tabs: {
    reference: 'Référence',
    libelle: 'Libellé',
    type: 'Type',
    societe: 'Société',
    agence: 'Agence',
    actif: 'Archivé',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    categorie: 'Liste des types de produits',
    actif: 'Actif',
    yes: 'Oui',
    no: 'Non',
    societe: 'Societé',
    agence: 'Agence',
    motifNonCommercialisation: 'Motif(s) de non commercialisation',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  archivage: {
    title: 'Etes-vous sûr de vouloir archiver ce produit ?',
    produitReseauArchiver: 'Produit réseau archivé avec succès',
    produitReseauLcArchiver: 'Produit réseau lc archivé avec succès',
    produitReseauMairieArchiver: 'Produit réseau mairie archivé avec succès',
    produitReseauNumeriqueArchiver: 'Produit réseau numérique archivé avec succès',
    produitLocationArchiver: 'Produit location archivé avec succès',
    produitDiversArchiver: 'Produit divers archivé avec succès',
    produitFaceArchiver: 'Produit face archivé avec succès',
    produitNumeriqueArchiver: 'Produit numérique archivé avec succès',
  },
  desarchivage: {
    title: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    produitReseauArchiver: 'Produit réseau désarchivé avec succès',
    produitReseauLcArchiver: 'Produit réseau lc désarchivé avec succès',
    produitReseauMairieArchiver: 'Produit réseau mairie désarchivé avec succès',
    produitReseauNumeriqueArchiver: 'Produit réseau numérique désarchivé avec succès',
    produitLocationArchiver: 'Produit location désarchivé avec succès',
    produitDiversArchiver: 'Produit divers désarchivé avec succès',
    produitFaceArchiver: 'Produit face désarchivé avec succès',
    produitNumeriqueArchiver: 'Produit numérique désarchivé avec succès',
  },
};

export default LISTE_PRODUITS_NON_COMMERCIALISABLE;
